module.exports = __webpack_public_path__ + "img/qr_code_badge_white_en.ea272f1f.svg";